import { render, staticRenderFns } from "./shangchuan.vue?vue&type=template&id=5e321aa1&"
import script from "./shangchuan.vue?vue&type=script&lang=ts&"
export * from "./shangchuan.vue?vue&type=script&lang=ts&"
import style0 from "./shangchuan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports